import { ViewableFile } from '@modules/settings/my-numbers/purchase-number/hooks/use-upload-media';
import {
  RiFileExcelLine,
  RiFilePdf2Line,
  RiFilePptLine,
  RiFileTextLine,
  RiFileWordLine,
  RiFileZipLine,
} from 'react-icons/ri';

export const isImageFile = (file: ViewableFile) => {
  const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'];
  return file.type ? imageTypes.includes(file.type) : /\.(jpe?g|png|gif|webp|svg)$/i.test(file.name);
};

export const getFileTypeIcon = (file: ViewableFile) => {
  const name = file.name.toLowerCase();
  if (name.endsWith('.pdf')) return { icon: <RiFilePdf2Line />, bg: 'bg-red-50', text: 'text-red-500', label: 'PDF' };
  if (name.match(/\.docx?$/))
    return { icon: <RiFileWordLine />, bg: 'bg-blue-50 dark:bg-blue-500/15', text: 'text-blue-500', label: 'DOC' };
  if (name.match(/\.xlsx?|\.csv$/))
    return { icon: <RiFileExcelLine />, bg: 'bg-green-50', text: 'text-green-600', label: 'XLS' };
  if (name.match(/\.pptx?$/))
    return { icon: <RiFilePptLine />, bg: 'bg-orange-50 dark:bg-orange-500/15', text: 'text-orange-500', label: 'PPT' };
  if (name.match(/\.zip|\.rar|\.7z|\.tar|\.gz$/))
    return { icon: <RiFileZipLine />, bg: 'bg-yellow-50 dark:bg-yellow-500/15', text: 'text-yellow-600', label: 'ZIP' };
  return { icon: <RiFileTextLine />, bg: 'bg-gray-50', text: 'text-gray-500', label: 'FILE' };
};
